import { NativeBridgeProvider } from "@bridge/provider"
import { Outlet } from "react-router"

export default function AppLayout() {
  return (
    <NativeBridgeProvider>
      <Outlet />
    </NativeBridgeProvider>
  )
}
